import { Base, base } from "./base"

export type LetterSpacings = Base

export const letterSpacings: LetterSpacings = {
  ...base
}
